export const USER_ROLES = {
  INFRA_ADMIN: "infraAdmin",
  MANAGER: "manager",
  MENTORSHIP_ADMIN: "mentorshipAdmin",
  CC_INTERNAL: "ccInternal",
  MENTORSHIP: "mentorship",
  CONTACT_GOOGLE_CHAT: "contactGoogleChat",
};
